import React from 'react';
import styled from 'styled-components';
import { Box } from '../../../../wag-react/next-components/box';
import { Flex } from '../../../../wag-react/core-components/flex';
import { Text } from '../../../../wag-react/core-components/text';
import { Image } from '../../../../wag-react/next-components/image';
import { GetStartedButton } from '../../../../components/GetStartedButton';
import pawsEllipse from './assets/paws-ellipse.svg';
import starRating from '../../assets/star-rating.svg';
import caregiver1 from './assets/Avatar.svg';
import caregiver2 from './assets/Avatar-1.svg';
import caregiver3 from './assets/Avatar-2.svg';
const StatCard = styled(Box)`
  display: flex;
  padding: 24px;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  flex: 1 0 0;
  min-width: 280px;
  border-radius: var(--20, 20px);
  border: 2px solid var(--Stroke-backgroundGray, #EDEDED);
  background: var(--Fill-grayBg, #FAFAFA);
`;
const StatsContainer = styled(Flex)`
  gap: 16px;
  overflow-x: auto;
  padding-bottom: 6px;
  ::-webkit-scrollbar {
    display: none;
  }
  scrollbar-width: none;
  -ms-overflow-style: none;
  justify-content: flex-start;
  margin-bottom: 12px;
  
  @media (min-width: 880px) {
    gap: 24px;
    overflow-x: visible;
    padding-bottom: 0;
    justify-content: center;
    margin-bottom: 20px;
  }
`;
const StatTitle = styled(Text)`
  align-self: stretch;
  color: var(--Text-midnightBlack, #222);
  font-family: "Hero New", sans-serif;
  font-size: var(--Font-Size-H5, 20px);
  font-style: normal;
  font-weight: 700;
  line-height: var(--Line-Height-H5, 28px);
  letter-spacing: var(--Letter-Spacing-0, 0px);
  margin-top: 20px;
  margin-bottom: 0;
`;
const StatSubtitle = styled(Text)`
  align-self: stretch;
  color: var(--Text-charcoal, #474747);
  font-family: "Hero New", sans-serif;
  font-size: var(--Font-Size-Body-2, 16px);
  font-style: normal;
  font-weight: 400;
  line-height: var(--Line-Height-Body-2, 24px);
  letter-spacing: var(--Letter-Spacing-0, 0px);
  margin-bottom: 0;
`;
export const StatsSection = () => {
  return <Box width={1} pl={[0, 4]} pr={[0, 4]} pb={[4]} bg="white" data-sentry-element="Box" data-sentry-component="StatsSection" data-sentry-source-file="index.tsx">
      <StatsContainer flexDirection="row" alignItems="stretch" maxWidth={1100} mx="auto" mb={0} py={0} px={[3, 0]} data-sentry-element="StatsContainer" data-sentry-source-file="index.tsx">
        <StatCard data-sentry-element="StatCard" data-sentry-source-file="index.tsx">
          <Box height="48px" width="48px" mb={2} data-sentry-element="Box" data-sentry-source-file="index.tsx">
            <Image src={pawsEllipse} alt="Paw icon" width="100%" height="100%" data-sentry-element="Image" data-sentry-source-file="index.tsx" />
          </Box>
          <Box data-sentry-element="Box" data-sentry-source-file="index.tsx">
            <StatTitle data-sentry-element="StatTitle" data-sentry-source-file="index.tsx">12,000,000+</StatTitle>
            <StatSubtitle mt={1} data-sentry-element="StatSubtitle" data-sentry-source-file="index.tsx">Completed services</StatSubtitle>
          </Box>
        </StatCard>

        <StatCard data-sentry-element="StatCard" data-sentry-source-file="index.tsx">
          <Flex alignItems="center" mb={2} data-sentry-element="Flex" data-sentry-source-file="index.tsx">
            <Box width="48px" height="48px" borderRadius="48px" overflow="hidden" border="0px solid white" position="relative" zIndex={1} data-sentry-element="Box" data-sentry-source-file="index.tsx">
              <Image src={caregiver1} alt="Pet Parent" width="100%" height="100%" objectFit="cover" data-sentry-element="Image" data-sentry-source-file="index.tsx" />
            </Box>
            <Box width="48px" height="48px" borderRadius="48px" overflow="hidden" border="0px solid white" position="relative" left="-12px" zIndex={2} data-sentry-element="Box" data-sentry-source-file="index.tsx">
              <Image src={caregiver2} alt="Pet Parent" width="100%" height="100%" objectFit="cover" data-sentry-element="Image" data-sentry-source-file="index.tsx" />
            </Box>
            <Box width="48px" height="48px" borderRadius="48px" overflow="hidden" border="0px solid white" position="relative" left="-24px" zIndex={3} data-sentry-element="Box" data-sentry-source-file="index.tsx">
              <Image src={caregiver3} alt="Pet Parent" width="100%" height="100%" objectFit="cover" data-sentry-element="Image" data-sentry-source-file="index.tsx" />
            </Box>
          </Flex>
          <Box data-sentry-element="Box" data-sentry-source-file="index.tsx">
            <StatTitle data-sentry-element="StatTitle" data-sentry-source-file="index.tsx">1,000,000+</StatTitle>
            <StatSubtitle mt={1} data-sentry-element="StatSubtitle" data-sentry-source-file="index.tsx">Pet Parents</StatSubtitle>
          </Box>
        </StatCard>

        <StatCard data-sentry-element="StatCard" data-sentry-source-file="index.tsx">
          <Box height="22px" mb={2} data-sentry-element="Box" data-sentry-source-file="index.tsx">
            <Image src={starRating} alt="5-star rating" width="100%" height="100%" data-sentry-element="Image" data-sentry-source-file="index.tsx" />
          </Box>
          <Box data-sentry-element="Box" data-sentry-source-file="index.tsx">
            <StatTitle data-sentry-element="StatTitle" data-sentry-source-file="index.tsx">Pet Parents love us</StatTitle>
            <StatSubtitle mt={1} data-sentry-element="StatSubtitle" data-sentry-source-file="index.tsx">4.8/5 From 42K reviews</StatSubtitle>
          </Box>
        </StatCard>
      </StatsContainer>

      <Flex justifyContent="center" width={1} data-sentry-element="Flex" data-sentry-source-file="index.tsx">
        <GetStartedButton data-sentry-element="GetStartedButton" data-sentry-source-file="index.tsx" />
      </Flex>
    </Box>;
};
export default StatsSection;